import DestinationInfoComponent from './DestinationInfoComponent';

export default DestinationInfoComponent;
